import api from "../axiosIntercepture";

export const getSearchBySkuPO = async (type, values) => {
    let rawValues = values;

// Process to get ["po001", "PO001"]
 let newValues = rawValues[0].split(',').map((val, index) =>
   val
);
    try {
        //   const response = await api.post("purchase-order/get-po", {
        const response = await api.post("purchase-order/get-po-multi", {
            type: type,  // 1 for PO Number, 2 for SKU ID , 3 for SO Number
            values: newValues
        });
        
        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }
        return [];
    } catch (err) {
        console.error("Error fetching PO/SKU data:", err);
        throw err?.response?.data?.message || "Failed to fetch data";
    }
}
export const createANS = async (payload) => {
    try {
        const response = await api.post("asn/create", payload);
        
        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }
        return [];
    } catch (err) {
        console.error("Error creating ANS:", err);
        throw err?.response?.data?.message || "Failed to create ANS";
    }

}
// export const uploadASN = async (file) => {
//   const form = new FormData();
//   form.append('file', file);
//   try {
//     const response = await api.post("upload/asn", form, {
//       headers: { 'Content-Type': 'multipart/form-data' }
//     });
    
//     // More robust response validation
//     if (!response.data || response.data.success === false) {
//       const errorMsg = response.data?.message || "ASN upload failed";
//       throw new Error(errorMsg);
//     }
    
//     return response.data;
//   } catch (err) {
//     console.error("Upload error details:", err);
    
//     // Better error message extraction and classification
//     let errorMessage = "ASN upload failed";
    
//     if (err.response?.data?.message) {
//       errorMessage = err.response.data.message;
//     } else if (err.message) {
//       errorMessage = err.message;
//     }
    
//     // Handle specific error types
//     if (errorMessage.includes("duplicate") || errorMessage.includes("Duplicate")) {
//       errorMessage = "This file contains ASN numbers that already exist in the system";
//     } else if (errorMessage.includes("validation") || errorMessage.includes("Validation")) {
//       errorMessage = "The uploaded file contains invalid data. Please check the format and try again.";
//     }
    
//     throw new Error(errorMessage);
//   }
// };

export const fetchASN = async (page, pageSize, filters) => {
  try {

      const sendObj = {
          filters: filters,
          limit: pageSize,
          page: page + 1
      }
      const response = await api.post(`asn/fetch-multi-dynamic`, sendObj);
    
    // More robust response validation
    if (!response.data?.success) {
      const errorMsg = response.data?.message || "Failed to fetch ASN data";
      throw new Error(errorMsg);
    }
    // Ensure we always return a valid array and never null/undefined
    return Array.isArray(response.data?.data.data) ? response.data.data : [];
  } catch (err) {
    console.error("Error fetching ASNs:", err);
    throw new Error(err?.response?.data?.message || "Failed to fetch ASN data");
  }
}


export const confirmASN = async (payload) => {
    try {
        const response = await api.post("asn/confirm-asn", payload);

        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }
        return [];
    } catch (err) {
        console.error("Error creating ANS:", err);
        throw err?.response?.data?.message || "Failed to create ANS";
    }

}

export const fetchAsnById = async (id) => {
  
    try {
        const response = await api.post(`asn/fetchById?id=${id}`);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const fetchAsnByAsnNumber = async (no) => {

    try {
        const response = await api.post(`asn/fetchASNByCode?id=${no}`);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

// export const exportASN = async (payload) => {
//   try {
//     const response = await api.post("asn/export", payload);
//     // Expecting base64 payload in response.data.data
//     return response.data?.data;
//   } catch (err) {
//     throw err?.response?.data?.message || "ASN export failed";
//   }
// };


export const updateASN = async (asnId, payload) => {
    if (!asnId) throw new Error("Missing identifier for updateASN");

    try {
        const encoded = encodeURIComponent(asnId);
        const response = await api.post(`asn/update/${encoded}`, payload);

        // Try to be flexible with different API shapes
        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }
        if (response.data) {
            return response.data;
        }

        return response;
    } catch (err) {
        console.error("Error updating ASN:", err);

        let errorMessage = "Failed to update ASN";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

        // small heuristics / helpful guidance (optional)
        if (errorMessage.toLowerCase().includes("asn")) {
            errorMessage = `${errorMessage}`;
        }

        throw new Error(errorMessage);
    }
};
